import React from 'react';
import { Field } from 'react-final-form';

import { saveCardField } from '../../SavePaymentInfo';

const ForceSaveDetailsCheckboxes: React.FC = () => (
  <Field name={saveCardField} type="checkbox" initialValue>
    {() => <input hidden name={saveCardField} type="checkbox" data-testid="force-save-checkbox" />}
  </Field>
);

export default ForceSaveDetailsCheckboxes;
